import React from 'react'
import styled from 'styled-components'

const HoverBox = styled.div`
  color: tomato;
  border-color: tomato;
  position:relative;
  vertical-align: middle;
  color: #0b7;
  text-align: center;
  transition: 0.5s;
  cursor: pointer;
  -webkit-transition:0.5s;
  padding: 7px;



  &:before, &:after {
    width: 100%;
    height: 364px;
    z-index: -1;
    content:'';
    position: absolute;
    top:0;
    left:0;
    box-sizing: border-box;
    -webkit-transform: scale(0);
    transition: 0.5s;
  }

  &:before {
    border-bottom: 7px solid ${(props) => props.color};
    border-left: 7px solid ${(props) => props.color};
    -webkit-transform-origin: 0 100%;
  }

  &:after {
    border-top: 7px solid ${(props) => props.color};
    border-right: 7px solid ${(props) => props.color};
    -webkit-transform-origin: 100% 0%;
  }

  &:hover::after, &:hover::before {
    -webkit-transform: scale(1);
  }
`

export default HoverBox



// WEBPACK FOOTER //
// ../components/styled/HoverBox.js